const TYPES_OF_ROUTES = ({ routes }) => ({
  fetchData: ({ appContext, ids, routeSelector }) => {
    const networkNestedRoute = appContext === 'backoffice' ? ids.network : null;

    return routes.ROUTES[routeSelector][appContext](networkNestedRoute);
  },
  fetchCategories: ({ ids, routeSelector }) =>
    routes.ROUTES_CATEGORIES({ ids })?.[routeSelector],
});

export const findUrl = ({ apiSettings, ids, routes, type }) => {
  const { routeSelector, appContext } = apiSettings;

  try {
    return TYPES_OF_ROUTES({ routes })[type]({
      appContext,
      ids,
      routeSelector,
    });
  } catch {
    // eslint-disable-next-line no-console
    console.warn(
      'Unable to find route based on given settings',
      JSON.stringify(apiSettings),
    );
  }
};
